module.exports = __webpack_public_path__ + "media/images/pic/team-1834986b187e41658c0bd7e1b30134d1.png";